import { useCallback, useMemo } from "react"
import { useAppDispatch, useAppSelector } from "../../store"
import { push } from "./slice"

export function useStoreCache() {
  const dispatch = useAppDispatch()
  const cache = useAppSelector(state => state.cache_slice.value)

  // Stable : Ne change jamais car dispatch est stable
  const pushToCache = useCallback((key: string, value: string | null) => {
    dispatch(push({ key, value }))
  }, [dispatch])

  // Dépend du cache : Sera mis à jour quand le cache change
  const getFromCache = useCallback((key: string) => {
    return cache[key]
  }, [cache])

  return useMemo(() => ({
    push: pushToCache,
    get: getFromCache,
    cache
  }), [cache, pushToCache, getFromCache])
}